export function SuperadminBanner() {
  return <div className="superadmin-banner">Superadmin mode · viewing all firm data</div>;
}
